import { Nav } from "@/components/landing/Nav";
import { DropTicker } from "@/components/landing/DropCountdown";
import { Hero } from "@/components/landing/Hero";
import { Banner } from "@/components/landing/Banner";
import { GiftBanners } from "@/components/landing/GiftBanners";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Categories } from "@/components/landing/Categories";
import { PalestineSpotlight } from "@/components/landing/PalestineSpotlight";
import { PurchasePopup } from "@/components/landing/PurchasePopup";
import { Pillars } from "@/components/landing/Pillars";
import { AmbassadorBanner } from "@/components/landing/AmbassadorBanner";
import { Signup } from "@/components/landing/Signup";
import { Footer } from "@/components/landing/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function DeenDistrict() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.querySelector(`[data-testid="${hash.slice(1)}"]`)?.scrollIntoView({ behavior: "smooth" }), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main className="bg-[#ffffff] text-[#0a0a0b] min-h-screen antialiased">
      <DropTicker />
      <Nav offset />
      <Hero />
      <Banner />
      <GiftBanners />
      <Marquee />
      <Manifesto />
      <Categories />
      <PalestineSpotlight />
      <Pillars />
      <AmbassadorBanner />
      <Signup />
      <Footer />
      <PurchasePopup />
    </main>
  );
}
